module.exports = __webpack_public_path__ + "img/s8Bg11.4749d725.jpg";